import getUsers from "../api/getUsers";
import getTenant from "../api/getTenant";
import getTenantInvoiceDetails from "../api/getTenantInvoiceDetails";
import getTenantAttestStats from "../api/getTenantAttestStats";
import getTenantProjectFormStats from "../api/getTenantProjectFormStats";
import getTenantBookingStats from "../api/getTenantBookingStats";
import getTenantGeneralInfo from "../api/getTenantGeneralInfo";
import getTenants from "../api/getTenants";
import getUserTenantConnections from "../api/getUserTenantConnections";
import postUser from "../api/postUser";
import postTenant from "../api/postTenant";
import postUserTenantConnection from "../api/postUserTenantConnection";
import putUser from "../api/putUser"
import putUserTenantConnection from "../api/putUserTenantConnection"
import deleteUser from "../api/deleteUser"
import deleteTenant from "../api/deleteTenant"
import deleteUserTenantConnection from "../api/deleteUserTenantConnection"
import login from "../api/login";
import getCurrentUser from "../api/getCurrentUser";
import getCreditCardReceipts from "../api/getCreditCardReceipts";
import getLanguages from "../api/getLanguages";
import getTenantLanguages from "../api/getTenantLanguages";
import getPaymentMethods from "../api/getPaymentMethods";
import getFeatureFlags from "../api/getFeatureFlags";
import getTenantFeatureFlags from "../api/getTenantFeatureFlags";
import getUserCertificates from "../api/getUserCertificates";
import getTenantSettings from "../api/getTenantSettings";
import postLanguage from "../api/postLanguage";
import postTenantLanguage from "../api/postTenantLanguage";
import postTenantFeatureFlag from "../api/postTenantFeatureFlag";
import postFeatureFlag from "../api/postFeatureFlag";
import postPaymentMethod from "../api/postPaymentMethod";
import postUserCertificate from "../api/postUserCertificate";
import putTenant from "../api/putTenant";
import putTenantMigrationStatus from "../api/putTenantMigrationStatus";
import putLanguage from "../api/putLanguage";
import putTenantLanguage from "../api/putTenantLanguage";
import putPaymentMethod from "../api/putPaymentMethod";
import putFeatureFlag from "../api/putFeatureFlag";
import putTenantFeatureFlag from "../api/putTenantFeatureFlag";
import putUserCertificate from "../api/putUserCertificate";
import putTenantSettings from "../api/putTenantSettings";
import deleteLanguage from "../api/deleteLanguage";
import deleteTenantLanguage from "../api/deleteTenantLanguage";
import deleteTenantFeatureFlag from "../api/deleteTenantFeatureFlag";
import deleteFeatureFlag from "../api/deleteFeatureFlag";
import deletePaymentMethod from "../api/deletePaymentMethod";
import deleteUserCertificate from "../api/deleteUserCertificate";
import postTenantFeaturesAdjusted from "../api/postTenantFeaturesAdjusted";
import postTenantDataVerified from "../api/postTenantDataVerified";
import getTenantEmployees from "../api/getTenantEmployees";
import getUser from "../api/getUser";
import getActiveUsersBetweenDates from "../api/getActiveUsersBetweenDates";
import getActiveUsersByDay from "../api/getActiveUsersByDay";
import getTenantCounts from "../api/getTenantCounts";
import getTenantActiveUsersBetweenDates from "../api/getTenantActiveUsersBetweenDates";
import getTenantActiveUsersByDay from "../api/getTenantActiveUsersByDay";
import getTenantByFeatureFlag from "../api/getTenantByFeatureFlag";
import getTenantData from "../api/getTenantData";
import postStartMigration from "../api/postStartMigration";
import postStartTestMigration from "../api/postStartTestMigration";
import getGadgetMigrationStatus from "../api/getGadgetMigrationStatus";
import getGadgetTestMigrationStatus from "../api/getGadgetTestMigrationStatus";


export const types = {
    SIGN_OUT: "SIGN_OUT",
    SIGN_IN_BEGIN: "SIGN_IN_BEGIN", 
    SIGN_IN_COMPLETE: "SIGN_IN_COMPLETE", 
    FETCH_USER_BEGIN: "FETCH_USER_BEGIN", 
    FETCH_USER_COMPLETE: "FETCH_USER_COMPLETE", 
    FETCH_USERS_BEGIN: "FETCH_USERS_BEGIN", 
    FETCH_USERS_COMPLETE: "FETCH_USERS_COMPLETE", 
    FETCH_TENANT_BEGIN: "FETCH_TENANT_BEGIN", 
    FETCH_TENANT_COMPLETE: "FETCH_TENANT_COMPLETE", 
    FETCH_TENANTS_BY_FEATURE_FLAG_BEGIN: "FETCH_TENANTS_BY_FEATURE_FLAG_BEGIN", 
    FETCH_TENANTS_BY_FEATURE_FLAG_COMPLETE: "FETCH_TENANTS_BY_FEATURE_FLAG_COMPLETE", 
    FETCH_TENANT_INVOICE_DETAILS_BEGIN: "FETCH_TENANT_INVOICE_DETAILS_BEGIN", 
    FETCH_TENANT_INVOICE_DETAILS_COMPLETE: "FETCH_TENANT_INVOICE_DETAILS_COMPLETE",
    FETCH_TENANT_ATTEST_STATS_BEGIN: "FETCH_TENANT_ATTEST_STATS_BEGIN",
    FETCH_TENANT_ATTEST_STATS_COMPLETE: "FETCH_TENANT_ATTEST_STATS_COMPLETE",
    FETCH_TENANT_PROJECT_FORM_STATS_BEGIN: "FETCH_TENANT_PROJECT_FORM_STATS_BEGIN",
    FETCH_TENANT_PROJECT_FORM_STATS_COMPLETE: "FETCH_TENANT_PROJECT_FORM_STATS_COMPLETE",
    FETCH_TENANT_BOOKING_STATS_BEGIN: "FETCH_TENANT_BOOKING_STATS_BEGIN",
    FETCH_TENANT_BOOKING_STATS_COMPLETE: "FETCH_TENANT_BOOKING_STATS_COMPLETE",
    FETCH_TENANT_GENERAL_INFO_BEGIN: "FETCH_TENANT_GENERAL_INFO_BEGIN",
    FETCH_TENANT_GENERAL_INFO_COMPLETE: "FETCH_TENANT_GENERAL_INFO_COMPLETE",
    FETCH_TENANTS_BEGIN: "FETCH_TENANTS_BEGIN", 
    FETCH_TENANTS_COMPLETE: "FETCH_TENANTS_COMPLETE", 
    FETCH_USER_TENANT_CONNECTIONS_BEGIN: "FETCH_USER_TENANT_CONNECTIONS_BEGIN", 
    FETCH_USER_TENANT_CONNECTIONS_COMPLETE: "FETCH_USER_TENANT_CONNECTIONS_COMPLETE",
    FETCH_CREDIT_CARD_RECEIPTS_BEGIN: "FETCH_CREDIT_CARD_RECEIPTS_BEGIN",
    FETCH_CREDIT_CARD_RECEIPTS_COMPLETE: "FETCH_CREDIT_CARD_RECEIPTS_COMPLETE",
    FETCH_LANGUAGES_BEGIN: "FETCH_LANGUAGES_BEGIN",
    FETCH_LANGUAGES_COMPLETE: "FETCH_LANGUAGES_COMPLETE",
    FETCH_TENANT_LANGUAGES_BEGIN: "FETCH_TENANT_LANGUAGES_BEGIN",
    FETCH_TENANT_LANGUAGES_COMPLETE: "FETCH_TENANT_LANGUAGES_COMPLETE",
    FETCH_PAYMENT_METHODS_BEGIN: "FETCH_PAYMENT_METHODS_BEGIN",
    FETCH_PAYMENT_METHODS_COMPLETE: "FETCH_PAYMENT_METHODS_COMPLETE",
    FETCH_FEATURE_FLAGS_BEGIN: "FETCH_FEATURE_FLAGS_BEGIN",
    FETCH_FEATURE_FLAGS_COMPLETE: "FETCH_FEATURE_FLAGS_COMPLETE",
    FETCH_FEATURE_FLAG_BEGIN: "FETCH_FEATURE_FLAG_BEGIN",
    FETCH_FEATURE_FLAG_COMPLETE: "FETCH_FEATURE_FLAG_COMPLETE",
    FETCH_TENANT_FEATURE_FLAGS_BEGIN: "FETCH_TENANT_FEATURE_FLAGS_BEGIN",
    FETCH_TENANT_FEATURE_FLAGS_COMPLETE: "FETCH_TENANT_FEATURE_FLAGS_COMPLETE",
    FETCH_TENANT_SETTINGS_BEGIN: "FETCH_TENANT_SETTINGS_BEGIN",
    FETCH_TENANT_SETTINGS_COMPLETE: "FETCH_TENANT_SETTINGS_COMPLETE",
    FETCH_USER_CERTIFICATES_BEGIN: "FETCH_USER_CERTIFICATES_BEGIN",
    FETCH_USER_CERTIFICATES_COMPLETE: "FETCH_USER_CERTIFICATES_COMPLETE",
    FETCH_TENANT_EMPLOYEES_BEGIN: "FETCH_TENANT_EMPLOYEES_BEGIN", 
    FETCH_TENANT_EMPLOYEES_COMPLETE: "FETCH_TENANT_EMPLOYEES_COMPLETE", 
    CREATE_USER_BEGIN: "CREATE_USER_BEGIN",
    CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
    CREATE_TENANT_BEGIN: "CREATE_TENANT_BEGIN",
    CREATE_TENANT_SUCCESS: "CREATE_TENANT_SUCCESS",
    CREATE_USER_TENANT_CONNECTION_BEGIN: "CREATE_USER_TENANT_CONNECTION_BEGIN",
    CREATE_USER_TENANT_CONNECTION_SUCCESS: "CREATE_USER_TENANT_CONNECTION_SUCCESS",
    CREATE_LANGUAGE_BEGIN: "CREATE_LANGUAGE_BEGIN",
    CREATE_LANGUAGE_COMPLETE: "CREATE_LANGUAGE_COMPLETE",
    CREATE_TENANT_LANGUAGE_BEGIN: "CREATE_TENANT_LANGUAGE_BEGIN",
    CREATE_TENANT_LANGUAGE_COMPLETE: "CREATE_TENANT_LANGUAGE_COMPLETE",
    CREATE_PAYMENT_METHOD_BEGIN: "CREATE_PAYMENT_METHOD_BEGIN",
    CREATE_PAYMENT_METHOD_COMPLETE: "CREATE_PAYMENT_METHOD_COMPLETE",
    CREATE_FEATURE_FLAG_BEGIN: "CREATE_FEATURE_FLAG_BEGIN",
    CREATE_FEATURE_FLAG_COMPLETE: "CREATE_FEATURE_FLAG_COMPLETE",
    CREATE_TENANT_FEATURE_FLAG_BEGIN: "CREATE_TENANT_FEATURE_FLAG_BEGIN",
    CREATE_TENANT_FEATURE_FLAG_COMPLETE: "CREATE_TENANT_FEATURE_FLAG_COMPLETE",
    CREATE_USER_CERTIFICATE_BEGIN: "CREATE_USER_CERTIFICATE_BEGIN",
    CREATE_USER_CERTIFICATE_COMPLETE: "CREATE_USER_CERTIFICATE_COMPLETE",
    UPDATE_USER_BEGIN: "UPDATE_USER_BEGIN",
    UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
    UPDATE_TENANT_BEGIN: "UPDATE_TENANT_BEGIN",
    UPDATE_TENANT_SUCCESS: "UPDATE_TENANT_SUCCESS",
    UPDATE_TENANT_MIGRATION_STATUS_BEGIN: "UPDATE_TENANT_MIGRATION_STATUS_EGIN",
    UPDATE_TENANT_MIGRATION_STATUS_SUCCESS: "UPDATE_TENANT_MIGRATION_STATUS_SUCCESS",
    UPDATE_USER_TENANT_CONNECTION_BEGIN: "UPDATE_USER_TENANT_CONNECTION_BEGIN",
    UPDATE_USER_TENANT_CONNECTION_SUCCESS: "UPDATE_USER_TENANT_CONNECTION_SUCCESS",
    UPDATE_CREDIT_CARD_RECEIPT_BEGIN: "UPDATE_CREDIT_CARD_RECEIPT_BEGIN",
    UPDATE_CREDIT_CARD_RECEIPT_COMPLETE: "UPDATE_CREDIT_CARD_RECEIPT_COMPLETE",
    UPDATE_LANGUAGE_BEGIN: "UPDATE_LANGUAGE_BEGIN",
    UPDATE_LANGUAGE_COMPLETE: "UPDATE_LANGUAGE_COMPLETE",
    UPDATE_TENANT_LANGUAGE_BEGIN: "UPDATE_TENANT_LANGUAGE_BEGIN",
    UPDATE_TENANT_LANGUAGE_COMPLETE: "UPDATE_TENANT_LANGUAGE_COMPLETE",
    UPDATE_PAYMENT_METHOD_BEGIN: "UPDATE_PAYMENT_METHOD_BEGIN",
    UPDATE_PAYMENT_METHOD_COMPLETE: "UPDATE_PAYMENT_METHOD_COMPLETE",
    UPDATE_FEATURE_FLAG_BEGIN: "UPDATE_FEATURE_FLAG_BEGIN",
    UPDATE_FEATURE_FLAG_COMPLETE: "UPDATE_FEATURE_FLAG_COMPLETE",
    UPDATE_TENANT_FEATURE_FLAG_BEGIN: "UPDATE_TENANT_FEATURE_FLAG_BEGIN",
    UPDATE_TENANT_FEATURE_FLAG_COMPLETE: "UPDATE_TENANT_FEATURE_FLAG_COMPLETE",
    UPDATE_TENANT_SETTING_BEGIN: "UPDATE_TENANT_SETTING_BEGIN",
    UPDATE_TENANT_SETTING_COMPLETE: "UPDATE_TENANT_SETTING_COMPLETE",
    UPDATE_USER_CERTIFICATE_BEGIN: "UPDATE_USER_CERTIFICATE_BEGIN",
    UPDATE_USER_CERTIFICATE_COMPLETE: "UPDATE_USER_CERTIFICATE_COMPLETE",
    DELETE_USER_BEGIN: "DELETE_USER_BEGIN",
    DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
    DELETE_TENANT_BEGIN: "DELETE_TENANT_BEGIN",
    DELETE_TENANT_SUCCESS: "DELETE_TENANT_SUCCESS",
    DELETE_USER_TENANT_CONNECTION_BEGIN: "DELETE_USER_TENANT_CONNECTION_BEGIN",
    DELETE_USER_TENANT_CONNECTION_SUCCESS: "DELETE_USER_TENANT_CONNECTION_SUCCESS",
    DELETE_CREDIT_CARD_RECEIPT_BEGIN: "DELETE_CREDIT_CARD_RECEIPT_BEGIN",
    DELETE_CREDIT_CARD_RECEIPT_COMPLETE: "DELETE_CREDIT_CARD_RECEIPT_COMPLETE",
    DELETE_LANGUAGE_BEGIN: "DELETE_LANGUAGE_BEGIN",
    DELETE_LANGUAGE_COMPLETE: "DELETE_LANGUAGE_COMPLETE",
    DELETE_TENANT_LANGUAGE_BEGIN: "DELETE_TENANT_LANGUAGE_BEGIN",
    DELETE_TENANT_LANGUAGE_COMPLETE: "DELETE_TENANT_LANGUAGE_COMPLETE",
    DELETE_PAYMENT_METHOD_BEGIN: "DELETE_PAYMENT_METHOD_BEGIN",
    DELETE_PAYMENT_METHOD_COMPLETE: "DELETE_PAYMENT_METHOD_COMPLETE",
    DELETE_FEATURE_FLAG_BEGIN: "DELETE_FEATURE_FLAG_BEGIN",
    DELETE_FEATURE_FLAG_COMPLETE: "DELETE_FEATURE_FLAG_COMPLETE",
    DELETE_TENANT_FEATURE_FLAG_BEGIN: "DELETE_TENANT_FEATURE_FLAG_BEGIN",
    DELETE_TENANT_FEATURE_FLAG_COMPLETE: "DELETE_TENANT_FEATURE_FLAG_COMPLETE",
    DELETE_USER_CERTIFICATE_BEGIN: "DELETE_USER_CERTIFICATE_BEGIN",
    DELETE_USER_CERTIFICATE_COMPLETE: "DELETE_USER_CERTIFICATE_COMPLETE",
    REQUEST_STARTED: 'REQUEST_STARTED',
    REQUEST_COMPLETED: 'REQUEST_COMPLETED',
    LOAD_TENANTS_COUNT_BEGIN: "LOAD_TENANTS_COUNT_BEGIN",
    LOAD_TENANTS_COUNT_SUCCESS: "LOAD_TENANTS_COUNT_SUCCESS",
    LOAD_ACTIVE_USERS_BETWEEN_DATES_BEGIN: "LOAD_ACTIVE_USERS_BETWEEN_DATES_BEGIN",
    LOAD_ACTIVE_USERS_BETWEEN_DATES_SUCCESS: "LOAD_ACTIVE_USERS_BETWEEN_DATES_SUCCESS",
    LOAD_ACTIVE_USERS_BETWEEN_DATES2_BEGIN: "LOAD_ACTIVE_USERS_BETWEEN_DATES2_BEGIN",
    LOAD_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS: "LOAD_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS",
    LOAD_ACTIVE_USERS_BY_DAY_BEGIN: "LOAD_ACTIVE_USERS_BY_DAY_BEGIN",
    LOAD_ACTIVE_USERS_BY_DAY_SUCCESS: "LOAD_ACTIVE_USERS_BY_DAY_SUCCESS",
    LOAD_ACTIVE_USERS_BY_DAY2_BEGIN: "LOAD_ACTIVE_USERS_BY_DAY2_BEGIN",
    LOAD_ACTIVE_USERS_BY_DAY2_SUCCESS: "LOAD_ACTIVE_USERS_BY_DAY2_SUCCESS",
    LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_BEGIN: "LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_BEGIN",
    LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_SUCCESS: "LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_SUCCESS",
    LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_BEGIN: "LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_BEGIN",
    LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS: "LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS",
    LOAD_TENANT_ACTIVE_USERS_BY_DAY_BEGIN: "LOAD_TENANT_ACTIVE_USERS_BY_DAY_BEGIN",
    LOAD_TENANT_ACTIVE_USERS_BY_DAY_SUCCESS: "LOAD_TENANT_ACTIVE_USERS_BY_DAY_SUCCESS",
    LOAD_TENANT_ACTIVE_USERS_BY_DAY2_BEGIN: "LOAD_TENANT_ACTIVE_USERS_BY_DAY2_BEGIN",
    LOAD_TENANT_ACTIVE_USERS_BY_DAY2_SUCCESS: "LOAD_TENANT_ACTIVE_USERS_BY_DAY2_SUCCESS",
    LOAD_TENANT_DATA_BEGIN: "LOAD_TENANT_DATA_BEGIN",
    LOAD_TENANT_DATA_SUCCESS: "LOAD_TENANT_DATA_SUCCESS",
    START_MIGRATION_BEGIN: "START_MIGRATION_BEGIN",
    START_TEST_MIGRATION_BEGIN: "START_TEST_MIGRATION_BEGIN",
    START_MIGRATION_SUCCESS: "START_MIGRATION_SUCCESS",
    START_TEST_MIGRATION_SUCCESS: "START_TEST_MIGRATION_SUCCESS",
    CHECK_GADGET_MIGRATION_STATUS_BEGIN: "CHECK_GADGET_MIGRATION_STATUS_BEGIN",
    CHECK_GADGET_MIGRATION_STATUS_SUCCESS: "CHECK_GADGET_MIGRATION_STATUS_SUCCESS",
    CHECK_GADGET_TEST_MIGRATION_STATUS_BEGIN: "CHECK_GADGET_TEST_MIGRATION_STATUS_BEGIN",
    CHECK_GADGET_TEST_MIGRATION_STATUS_SUCCESS: "CHECK_GADGET_TEST_MIGRATION_STATUS_SUCCESS",
}

export const signOut = () => ({ type: types.SIGN_OUT })
export const signInBegin = () => ({ type: types.SIGN_IN_BEGIN });
export const signInComplete = (payload) => ({ type: types.SIGN_IN_COMPLETE, payload});

export const fetchTenantDataBegin = () => ({ type: types.LOAD_TENANT_DATA_BEGIN });
export const fetchTenantDataComplete = (payload) => ({ type: types.LOAD_TENANT_DATA_SUCCESS, payload });

export const fetchUserBegin = () => ({ type: types.FETCH_USER_BEGIN });
export const fetchUserComplete = (payload) => ({ type: types.FETCH_USER_COMPLETE, payload });
export const fetchUsersBegin = () => ({ type: types.FETCH_USERS_BEGIN });
export const fetchUsersComplete = (payload) => ({ type: types.FETCH_USERS_COMPLETE, payload });
export const fetchTenantBegin = () => ({ type: types.FETCH_TENANT_BEGIN });
export const fetchTenantComplete = (payload) => ({ type: types.FETCH_TENANT_COMPLETE, payload });
export const fetchTenantsByFeatureFlagBegin = () => ({ type: types.FETCH_TENANTS_BY_FEATURE_FLAG_BEGIN });
export const fetchTenantsByFeatureFlagComplete = (payload) => ({ type: types.FETCH_TENANTS_BY_FEATURE_FLAG_COMPLETE, payload });
export const fetchTenantInvoiceDetailsBegin = () => ({ type: types.FETCH_TENANT_INVOICE_DETAILS_BEGIN });
export const fetchTenantInvoiceDetailsComplete = (payload) => ({ type: types.FETCH_TENANT_INVOICE_DETAILS_COMPLETE, payload });
export const fetchTenantAttestStatsBegin = () => ({ type: types.FETCH_TENANT_ATTEST_STATS_BEGIN });
export const fetchTenantAttestStatsComplete = (payload) => ({ type: types.FETCH_TENANT_ATTEST_STATS_COMPLETE, payload });
export const fetchTenantProjectFormStatsBegin = () => ({ type: types.FETCH_TENANT_PROJECT_FORM_STATS_BEGIN });
export const fetchTenantProjectFormStatsComplete = (payload) => ({ type: types.FETCH_TENANT_PROJECT_FORM_STATS_COMPLETE, payload });
export const fetchTenantBookingStatsBegin = () => ({ type: types.FETCH_TENANT_BOOKING_STATS_BEGIN });
export const fetchTenantBookingStatsComplete = (payload) => ({ type: types.FETCH_TENANT_BOOKING_STATS_COMPLETE, payload });
export const fetchTenantGeneralInfoBegin = () => ({ type: types.FETCH_TENANT_GENERAL_INFO_BEGIN });
export const fetchTenantGeneralInfoComplete = (payload) => ({ type: types.FETCH_TENANT_GENERAL_INFO_COMPLETE, payload });
export const fetchTenantsBegin = () => ({ type: types.FETCH_TENANTS_BEGIN });
export const fetchTenantsComplete = (payload) => ({ type: types.FETCH_TENANTS_COMPLETE, payload });
export const fetchUserTenantConnectionsBegin = () => ({ type: types.FETCH_USER_TENANT_CONNECTIONS_BEGIN });
export const fetchUserTenantConnectionsComplete = (payload) => ({ type: types.FETCH_USER_TENANT_CONNECTIONS_COMPLETE, payload });
export const fetchCreditCardReceiptsBegin  = () => ({ type: types.FETCH_CREDIT_CARD_RECEIPTS_BEGIN })
export const fetchCreditCardReceiptsComplete = (payload) => ({ type: types.FETCH_CREDIT_CARD_RECEIPTS_COMPLETE, payload })
export const fetchLanguagesBegin = () => ({ type: types.FETCH_LANGUAGES_BEGIN })
export const fetchLanguageComplete = (payload) => ({ type: types.FETCH_LANGUAGES_COMPLETE, payload })
export const fetchTenantLanguagesBegin = () => ({ type: types.FETCH_TENANT_LANGUAGES_BEGIN })
export const fetchTenantLanguagesComplete = (payload) => ({ type: types.FETCH_TENANT_LANGUAGES_COMPLETE, payload })
export const fetchPaymentMethodsBegin = () => ({ type: types.FETCH_PAYMENT_METHODS_BEGIN })
export const fetchPaymentMethodsComplete = (payload) => ({ type: types.FETCH_PAYMENT_METHODS_COMPLETE, payload })
export const fetchFeatureFlagsBegin = () => ({ type: types.FETCH_FEATURE_FLAGS_BEGIN })
export const fetchFeatureFlagsComplete = (payload) => ({ type: types.FETCH_FEATURE_FLAGS_COMPLETE, payload })
export const fetchFeatureFlagBegin = () => ({ type: types.FETCH_FEATURE_FLAG_BEGIN })
export const fetchFeatureFlagComplete = (payload) => ({ type: types.FETCH_FEATURE_FLAG_COMPLETE, payload })
export const fetchTenantFeatureFlagsBegin = () => ({ type: types.FETCH_TENANT_FEATURE_FLAGS_BEGIN })
export const fetchTenantFeatureFlagsComplete = (payload) => ({ type: types.FETCH_TENANT_FEATURE_FLAGS_COMPLETE, payload })
export const fetchUserCertificatesBegin = () => ({ type: types.FETCH_USER_CERTIFICATES_BEGIN })
export const fetchUserCertificatesComplete = (payload) => ({ type: types.FETCH_USER_CERTIFICATES_COMPLETE, payload })
export const fetchTenantSettingsBegin = () => ({ type: types.FETCH_TENANT_SETTINGS_BEGIN })
export const fetchTenantSettingsComplete = (payload) => ({ type: types.FETCH_TENANT_SETTINGS_COMPLETE, payload })
export const fetchTenantEmployeesBegin = () => ({ type: types.FETCH_TENANT_EMPLOYEES_BEGIN })
export const fetchTenantEmployeesComplete = (payload) => ({ type: types.FETCH_TENANT_EMPLOYEES_COMPLETE, payload })

export const createUserBegin = () => ({ type: types.CREATE_USER_BEGIN })
export const createUserSuccess = () => ({ type: types.CREATE_USER_SUCCESS })
export const createTenantBegin = () => ({ type: types.CREATE_TENANT_BEGIN })
export const createTenantSuccess = () => ({ type: types.CREATE_TENANT_SUCCESS })
export const createUserTenantConnectionBegin = () => ({ type: types.CREATE_USER_TENANT_CONNECTION_BEGIN })
export const createUserTenantConnectionSuccess = () => ({ type: types.CREATE_USER_TENANT_CONNECTION_SUCCESS })
export const createLanguageBegin = () => ({ type: types.CREATE_LANGUAGE_BEGIN })
export const createLanguageComplete = () => ({ type: types.CREATE_LANGUAGE_COMPLETE })
export const createTenantLanguageBegin = () => ({ type: types.CREATE_TENANT_LANGUAGE_BEGIN })
export const createTenantLanguageComplete = () => ({ type: types.CREATE_TENANT_LANGUAGE_COMPLETE })
export const createPaymentMethodBegin = () => ({ type: types.CREATE_PAYMENT_METHOD_BEGIN })
export const createPaymentMethodComplete = () => ({ type: types.CREATE_PAYMENT_METHOD_COMPLETE })
export const createFeatureFlagBegin = () => ({ type: types.CREATE_FEATURE_FLAG_BEGIN })
export const createFeatureFlagComplete = () => ({ type: types.CREATE_FEATURE_FLAG_COMPLETE })
export const createTenantFeatureFlagBegin = () => ({ type: types.CREATE_TENANT_FEATURE_FLAG_BEGIN })
export const createTenantFeatureFlagComplete = () => ({ type: types.CREATE_TENANT_FEATURE_FLAG_COMPLETE })
export const createUserCertificateBegin = () => ({ type: types.CREATE_USER_CERTIFICATE_BEGIN })
export const createUserCertificateComplete = () => ({ type: types.CREATE_USER_CERTIFICATE_COMPLETE })

export const updateUserBegin = () => ({ type: types.UPDATE_USER_BEGIN })
export const updateUserSuccess = () => ({ type: types.UPDATE_USER_SUCCESS })
export const updateTenantBegin = () => ({ type: types.UPDATE_TENANT_BEGIN })
export const updateTenantSuccess = () => ({ type: types.UPDATE_TENANT_SUCCESS })
export const updateTenantMigrationStatusBegin = () => ({ type: types.UPDATE_TENANT_MIGRATION_STATUS_BEGIN })
export const updateTenantMigrationStatusSuccess = (payload) => ({ type: types.UPDATE_TENANT_MIGRATION_STATUS_SUCCESS, payload })
export const updateUserTenantConnectionBegin = () => ({ type: types.UPDATE_USER_TENANT_CONNECTION_BEGIN })
export const updateUserTenantConnectionSuccess = () => ({ type: types.UPDATE_USER_TENANT_CONNECTION_SUCCESS })
export const updateLanguageBegin = () => ({ type: types.UPDATE_LANGUAGE_BEGIN })
export const updateLanguageComplete = () => ({ type: types.UPDATE_LANGUAGE_COMPLETE })
export const updateTenantLanguageBegin = () => ({ type: types.UPDATE_TENANT_LANGUAGE_BEGIN })
export const updateTenantLanguageComplete = () => ({ type: types.UPDATE_TENANT_LANGUAGE_COMPLETE })
export const updatePaymentMethodBegin = () => ({ type: types.UPDATE_PAYMENT_METHOD_BEGIN })
export const updatePaymentMethodComplete = () => ({ type: types.UPDATE_PAYMENT_METHOD_COMPLETE })
export const updateFeatureFlagBegin = () => ({ type: types.UPDATE_FEATURE_FLAG_BEGIN })
export const updateFeatureFlagComplete = () => ({ type: types.UPDATE_FEATURE_FLAG_COMPLETE })
export const updateTenantFeatureFlagBegin = () => ({ type: types.UPDATE_TENANT_FEATURE_FLAG_BEGIN })
export const updateTenantFeatureFlagComplete = () => ({ type: types.UPDATE_TENANT_FEATURE_FLAG_COMPLETE })
export const updateUserCertificateBegin = () => ({ type: types.UPDATE_USER_CERTIFICATE_BEGIN })
export const updateUserCertificateComplete = () => ({ type: types.UPDATE_USER_CERTIFICATE_COMPLETE })
export const updateTenantSettingsBegin = () => ({ type: types.UPDATE_TENANT_SETTING_BEGIN })
export const updateTenantSettingsComplete = () => ({ type: types.UPDATE_TENANT_SETTING_COMPLETE })

export const loadTenantsCountBegin = () => ({ type: types.LOAD_TENANTS_COUNT_BEGIN })
export const loadTenantsCountSuccess = (payload) => ({ type: types.LOAD_TENANTS_COUNT_SUCCESS, payload })

export const deleteUserBegin = () => ({ type: types.DELETE_USER_BEGIN })
export const deleteUserSuccess = () => ({ type: types.DELETE_USER_SUCCESS })
export const deleteTenantBegin = () => ({ type: types.DELETE_TENANT_BEGIN })
export const deleteTenantSuccess = () => ({ type: types.DELETE_TENANT_SUCCESS })
export const deleteUserTenantConnectionBegin = () => ({ type: types.DELETE_USER_TENANT_CONNECTION_BEGIN })
export const deleteUserTenantConnectionSuccess = () => ({ type: types.DELETE_USER_TENANT_CONNECTION_SUCCESS })
export const deleteLanguageBegin = () => ({ type: types.DELETE_LANGUAGE_BEGIN })
export const deleteLanguageComplete = () => ({ type: types.DELETE_LANGUAGE_COMPLETE })
export const deleteTenantLanguageBegin = () => ({ type: types.DELETE_TENANT_LANGUAGE_BEGIN })
export const deleteTenantLanguageComplete = () => ({ type: types.DELETE_TENANT_LANGUAGE_COMPLETE })
export const deletePaymentMethodBegin = () => ({ type: types.DELETE_PAYMENT_METHOD_BEGIN })
export const deletePaymentMethodComplete = () => ({ type: types.DELETE_PAYMENT_METHOD_COMPLETE })
export const deleteFeatureFlagBegin = () => ({ type: types.DELETE_FEATURE_FLAG_BEGIN })
export const deleteFeatureFlagComplete = () => ({ type: types.DELETE_FEATURE_FLAG_COMPLETE })
export const deleteTenantFeatureFlagBegin = () => ({ type: types.DELETE_TENANT_FEATURE_FLAG_BEGIN })
export const deleteTenantFeatureFlagComplete = () => ({ type: types.DELETE_TENANT_FEATURE_FLAG_COMPLETE })
export const deleteUserCertificateBegin = () => ({ type: types.DELETE_USER_CERTIFICATE_BEGIN })
export const deleteUserCertificateComplete = () => ({ type: types.DELETE_USER_CERTIFICATE_COMPLETE })
export const requestStarted = () => ({ type: types.REQUEST_STARTED });
export const requestCompleted = () => ({ type: types.REQUEST_COMPLETED });
export const loadActiveUsersBetweenDatesBegin = () => ({ type: types.LOAD_ACTIVE_USERS_BETWEEN_DATES_BEGIN })
export const loadActiveUsersBetweenDatesSuccess = (payload) => ({ type: types.LOAD_ACTIVE_USERS_BETWEEN_DATES_SUCCESS, payload })
export const loadActiveUsersBetweenDates2Begin = () => ({ type: types.LOAD_ACTIVE_USERS_BETWEEN_DATES2_BEGIN })
export const loadActiveUsersBetweenDates2Success = (payload) => ({ type: types.LOAD_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS, payload })
export const loadActiveUsersByDayBegin = () => ({ type: types.LOAD_ACTIVE_USERS_BY_DAY_BEGIN })
export const loadActiveUsersByDaySuccess = (payload) => ({ type: types.LOAD_ACTIVE_USERS_BY_DAY_SUCCESS, payload })
export const loadActiveUsersByDay2Begin = () => ({ type: types.LOAD_ACTIVE_USERS_BY_DAY2_BEGIN })
export const loadActiveUsersByDay2Success = (payload) => ({ type: types.LOAD_ACTIVE_USERS_BY_DAY2_SUCCESS, payload })
export const loadTenantActiveUsersBetweenDatesBegin = () => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_BEGIN })
export const loadTenantActiveUsersBetweenDatesSuccess = (payload) => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_SUCCESS, payload })
export const loadTenantActiveUsersBetweenDates2Begin = () => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_BEGIN })
export const loadTenantActiveUsersBetweenDates2Success = (payload) => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS, payload })
export const loadTenantActiveUsersByDayBegin = () => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BY_DAY_BEGIN })
export const loadTenantActiveUsersByDaySuccess = (payload) => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BY_DAY_SUCCESS, payload })
export const loadTenantActiveUsersByDay2Begin = () => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BY_DAY2_BEGIN })
export const loadTenantActiveUsersByDay2Success = (payload) => ({ type: types.LOAD_TENANT_ACTIVE_USERS_BY_DAY2_SUCCESS, payload })

export const startMigrationBegin = () => ({ type: types.START_MIGRATION_BEGIN })
export const startTestMigrationBegin = () => ({ type: types.START_TEST_MIGRATION_BEGIN })
export const startMigrationSuccess = (payload) => ({ type: types.START_MIGRATION_SUCCESS, payload })
export const startTestMigrationSuccess = (payload) => ({ type: types.START_TEST_MIGRATION_SUCCESS, payload })

export const checkGadgetMigrationStatusBegin = () => ({ type: types.CHECK_GADGET_MIGRATION_STATUS_BEGIN })
export const checkGadgetMigrationStatusSuccess = (payload) => ({ type: types.CHECK_GADGET_MIGRATION_STATUS_SUCCESS, payload })
export const checkGadgetTestMigrationStatusBegin = () => ({ type: types.CHECK_GADGET_TEST_MIGRATION_STATUS_BEGIN })
export const checkGadgetTestMigrationStatusSuccess = (payload) => ({ type: types.CHECK_GADGET_TEST_MIGRATION_STATUS_SUCCESS, payload })

export const loadActiveUsersByDay = (fromDate, toDate) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadActiveUsersByDayBegin())

    return getActiveUsersByDay(
        token,
        backend,
        fromDate,
        toDate,
        )
    .then(res => {

        dispatch(loadActiveUsersByDaySuccess(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const loadActiveUsersByDay2 = (fromDate, toDate) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadActiveUsersByDay2Begin())

    return getActiveUsersByDay(
        token,
        backend,
        fromDate,
        toDate,
        )
    .then(res => {

        dispatch(loadActiveUsersByDay2Success(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const loadTenantActiveUsersByDay = (fromDate, toDate, tenant) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadTenantActiveUsersByDayBegin())

    return getTenantActiveUsersByDay(
        token,
        backend,
        fromDate,
        toDate,
        tenant
        )
    .then(res => {

        dispatch(loadTenantActiveUsersByDaySuccess(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const loadTenantActiveUsersByDay2 = (fromDate, toDate, tenant) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadTenantActiveUsersByDay2Begin())

    return getTenantActiveUsersByDay(
        token,
        backend,
        fromDate,
        toDate,
        tenant
        )
    .then(res => {

        dispatch(loadTenantActiveUsersByDay2Success(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const loadTenantsCount = (from = "", to = "") => {
    return (dispatch, getState) => {

        const {
            app: { token },
        } = getState();
    
        dispatch(requestStarted())
        dispatch(loadTenantsCountBegin())
    
        return getTenantCounts(
            token,
            from,
            to
            )
        .then(res => {
    
            dispatch(loadTenantsCountSuccess(res))
            dispatch(requestCompleted())
    
            return res
        })
    }
}

export const loadActiveUsersBetweenDates2 = (fromDate, toDate) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadActiveUsersBetweenDates2Begin())

    return getActiveUsersBetweenDates(
        token,
        backend,
        fromDate,
        toDate,
        )
    .then(res => {

        dispatch(loadActiveUsersBetweenDates2Success(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const loadActiveUsersBetweenDates = (fromDate, toDate) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadActiveUsersBetweenDatesBegin())

    return getActiveUsersBetweenDates(
        token,
        backend,
        fromDate,
        toDate,
        )
    .then(res => {

        dispatch(loadActiveUsersBetweenDatesSuccess(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const loadTenantActiveUsersBetweenDates2 = (fromDate, toDate, tenant) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadTenantActiveUsersBetweenDates2Begin())

    return getTenantActiveUsersBetweenDates(
        token,
        backend,
        fromDate,
        toDate,
        tenant
        )
    .then(res => {

        dispatch(loadTenantActiveUsersBetweenDates2Success(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const loadTenantActiveUsersBetweenDates = (fromDate, toDate, tenant) => {

    return (dispatch, getState) => {

    const {
        app: { token, backend },
    } = getState();

    dispatch(requestStarted())
    dispatch(loadTenantActiveUsersBetweenDatesBegin())

    return getTenantActiveUsersBetweenDates(
        token,
        backend,
        fromDate,
        toDate,
        tenant
        )
    .then(res => {

        dispatch(loadTenantActiveUsersBetweenDatesSuccess(res))
        dispatch(requestCompleted())

        return res
    })
}}

export const signOutAction = () => {
    return (dispatch) => {
        window.localStorage.removeItem("token")
        dispatch(signOut()) 
    }
}

export const signInAction = (email, password) => {
    return (dispatch) => {
        dispatch(signInBegin())

        return login(email, password).then((res)=>{
            if(res.error) {
                window.alert(res.error)
                return
            }

            if(res.toastMessage) {
                window.alert(res.toastMessage)
                return
            }

            if(res.access_token) {
                return getCurrentUser(res.access_token).then(userRes => {
                    if(userRes.user.SystemAdmin === "true") {
                        dispatch(signInComplete(res.access_token))
                        window.localStorage.setItem("token", res.access_token)
                    } else {
                        window.alert("Du saknar System Admin behörighet")
                    }                 
                })
            }
        })
    }
}

export const fetchUser = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token },
        } = getState();
        dispatch(fetchUserBegin())

        return getUser(token, id)
            .then(res => {
                dispatch(fetchUserComplete(res.user));
            })
    }
}

export const fetchUsers = (page, search = "") => {
    return (dispatch, getState) => {
        const {
            app: { token },
        } = getState();
        dispatch(fetchUsersBegin())

        return getUsers(token, page, search)
            .then(res => {
                dispatch(fetchUsersComplete(res.users));
            })
    }
}

export const fetchTenantEmployees = (DB_NAME) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(fetchTenantEmployeesBegin())

        return getTenantEmployees(token, DB_NAME)
            .then(res => {
                dispatch(fetchTenantEmployeesComplete(res.data))
            })
    }
}

export const fetchTenant = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()
        dispatch(fetchTenantBegin())

        return getTenant(token, id)
            .then(res => {
                dispatch(fetchTenantComplete(res.tenant))
            })
    }
}

export const fetchTenantsByFeatureFlag = (id, search = "", type = "") => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()
        dispatch(fetchTenantsByFeatureFlagBegin())

        return getTenantByFeatureFlag(token, id, search, type)
            .then(res => {
                dispatch(fetchTenantsByFeatureFlagComplete(res.tenants))
                return res
            })
    }
}

export const fetchTenantInvoiceDetails = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()
        dispatch(fetchTenantInvoiceDetailsBegin())

        return getTenantInvoiceDetails(token, id)
            .then(res => {
                dispatch(fetchTenantInvoiceDetailsComplete(res))
            })
    }
}

export const fetchTenantAttestStats = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()
        dispatch(fetchTenantAttestStatsBegin())

        return getTenantAttestStats(token, id)
            .then(res => {
                dispatch(fetchTenantAttestStatsComplete(res))
            })
    }
}

export const fetchTenantProjectFormStats = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()
        dispatch(fetchTenantProjectFormStatsBegin())

        return getTenantProjectFormStats(token, id)
            .then(res => {
                dispatch(fetchTenantProjectFormStatsComplete(res))
            })
    }
}

export const fetchTenantBookingStats = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()
        dispatch(fetchTenantBookingStatsBegin())

        return getTenantBookingStats(token, id)
            .then(res => {
                dispatch(fetchTenantBookingStatsComplete(res))
            })
    }
}

export const fetchTenantGeneralInfo = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()
        dispatch(fetchTenantGeneralInfoBegin())

        return getTenantGeneralInfo(token, id)
            .then(res => {
                dispatch(fetchTenantGeneralInfoComplete(res))
            })
    }
}

export const fetchTenants = (page, search = "") => {
    return (dispatch, getState) => {
        const {
            app: { token },
        } = getState();
        dispatch(fetchTenantsBegin())

        return getTenants(token, page, search)
            .then(res => {
                dispatch(fetchTenantsComplete(res.tenants));
            })
    }
}

export const fetchUserTenantConnections = (page, {search, TenantID, UserID} = {search: "", TenantID: "", UserID: ""}) => {
    return (dispatch, getState) => {
        const {
            app: { token },
        } = getState();
        dispatch(fetchUserTenantConnectionsBegin())

        return getUserTenantConnections(token, search, page, TenantID, UserID)
            .then(res => {
                dispatch(fetchUserTenantConnectionsComplete(res.user_tenant_connections));
            })
    }
}

export const fetchCreditCardReceipts = (id, { TenantID }) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchCreditCardReceiptsBegin())

        return getCreditCardReceipts(token, id, TenantID)
            .then((res) => {
                dispatch(fetchCreditCardReceiptsComplete(res.creditCardReceipts));
            })
    }
}

export const fetchLanguages = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchLanguagesBegin())

        return getLanguages(token, id)
            .then((res) => {
                dispatch(fetchLanguageComplete(res.languages));
            })
    }
}

export const fetchTenantLanguages = (id, { TenantID }) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchTenantLanguagesBegin())

        return getTenantLanguages(token, id, TenantID)
            .then((res) => {
                dispatch(fetchTenantLanguagesComplete(res.tenantLanguages));
            })
    }
}

export const fetchPaymentMethods = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchPaymentMethodsBegin())

        return getPaymentMethods(token, id)
            .then((res) => {
                dispatch(fetchPaymentMethodsComplete(res.paymentMethods));
            })
    }
}

export const fetchFeatureFlags = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchFeatureFlagsBegin())

        return getFeatureFlags(token, id)
            .then((res) => {
                dispatch(fetchFeatureFlagsComplete(res.featureFlags));
            })
    }
}

export const fetchFeatureFlag = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchFeatureFlagBegin())

        return getFeatureFlags(token, id)
            .then((res) => {
                dispatch(fetchFeatureFlagComplete(res.featureFlag));
            })
    }
}

export const fetchTenantFeatureFlags = (id, { TenantID }) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchTenantFeatureFlagsBegin())

        return getTenantFeatureFlags(token, id, TenantID)
            .then((res) => {
                dispatch(fetchTenantFeatureFlagsComplete(res.tenantFeatureFlags));
            })
    }
}

export const fetchUserCertificates = (id, { UserID }) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchUserCertificatesBegin())

        return getUserCertificates(token, id, UserID)
            .then((res) => {
                dispatch(fetchUserCertificatesComplete(res.tenantFeatureFlags));
            })
    }
}

export const fetchTenantSettings = () => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(fetchTenantSettingsBegin())

        return getTenantSettings(token)
            .then((res) => {
                dispatch(fetchTenantSettingsComplete(res.tenantSettings));
            })
    }
}

export const createUser = (FirstName, LastName, Email, MobileNumber, SystemAdmin) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createUserBegin())

        return postUser(token, FirstName, LastName, Email, MobileNumber, SystemAdmin)
            .then(() => {
                dispatch(createUserSuccess())
            })
    }
}

export const createTenant = (FullName, ShortName, Type, Active, Live, BusinessStatus, BusinessComment, PrimaryContact, SecondaryContact) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createTenantBegin())

        return postTenant(token, FullName, ShortName, Type, Active, Live, BusinessStatus, BusinessComment, PrimaryContact, SecondaryContact)
            .then(() => {
                dispatch(createTenantSuccess())
            })
    }
}

export const createUserTenantConnection = (TenantID, UserID, TenantRole, TenantEmployeeID) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createTenantBegin())

        return postUserTenantConnection(token, TenantID, UserID, TenantRole, TenantEmployeeID)
            .then(() => {
                dispatch(createTenantSuccess())
            })
    }
}

export const createLanguage = (IsoLanguage, Description) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createLanguageBegin())

        return postLanguage(token, IsoLanguage, Description)
            .then(() => {
                dispatch(createLanguageComplete())
            })
    }
}

export const createTenantLanguage = (TenantID, LanguageID) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createTenantLanguageBegin())

        return postTenantLanguage(token, TenantID, LanguageID)
            .then(() => {
                dispatch(createTenantLanguageComplete())
            })
    }
}

export const createPaymentMethod = (PaymentName, Description, AccessToken) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createPaymentMethodBegin())

        return postPaymentMethod(token, PaymentName, Description, AccessToken)
            .then(() => {
                dispatch(createPaymentMethodComplete())
            })
    }
}

export const createFeatureFlag = (Active, FeatureName, FeatureDescription, PricePerMonth) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createFeatureFlagBegin())

        return postFeatureFlag(token, Active, FeatureName, FeatureDescription, PricePerMonth)
            .then(() => {
                dispatch(createFeatureFlagComplete())
            })
    }
}

export const createTenantFeatureFlag = (TenantID, FeatureFlagID) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createTenantFeatureFlagBegin())

        return postTenantFeatureFlag(token, TenantID, FeatureFlagID)
            .then(() => {
                dispatch(createTenantFeatureFlagComplete())
            })
    }
}

export const createUserCertificate = (TenantID, LanguageID) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(createUserCertificateBegin())

        return postUserCertificate(token, TenantID, LanguageID)
            .then(() => {
                dispatch(createUserCertificateComplete())
            })
    }
}

export const updateUser = (id, FirstName, LastName, Email, MobileNumber, SystemAdmin) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateUserBegin())

        return putUser(token, id, FirstName, LastName, Email, MobileNumber, SystemAdmin)
            .then(()=>{
                return dispatch(updateUserSuccess())
            })
    }
}

export const updateTenant = (id, FullName, ShortName, Type, Active, Live, BusinessStatus, BusinessComment, PrimaryContact, SecondaryContact) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateTenantBegin())

        return putTenant(token, id, FullName, ShortName, Type, Active, Live, BusinessStatus, BusinessComment, PrimaryContact, SecondaryContact)
            .then(() => {
                dispatch(updateTenantSuccess())
            })
    }
}

export const updateTenantMigrationStatus = (id, MigrationStatus) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateTenantMigrationStatusBegin())

        return putTenantMigrationStatus(token, id, MigrationStatus)
            .then((res) => {
                dispatch(updateTenantMigrationStatusSuccess(res.tenant))

                return res
            })
    }
}

export const updateUserTenantConnection = (id, TenantID, UserID, TenantRole, TenantEmployeeID) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateUserTenantConnectionBegin())

        return putUserTenantConnection(token, id, TenantID, UserID, TenantRole, TenantEmployeeID)
            .then(()=>{
                dispatch(updateUserTenantConnectionSuccess())
            })
    }
}

export const updateLanguage = (id, IsoLanguage, Description) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateLanguageBegin())

        return putLanguage(token, id, IsoLanguage, Description)
            .then(() => {
                dispatch(updateLanguageComplete())
            })
    }
}

export const updateTenantLanguage = (id, TenantID, LanguageID) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateTenantLanguageBegin())

        return putTenantLanguage(token, id, TenantID, LanguageID)
            .then(() => {
                dispatch(updateTenantLanguageComplete())
            })
    }
}

export const updatePaymentMethod = (id, PaymentName, Description, AccessToken) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updatePaymentMethodBegin())

        return putPaymentMethod(token, id, PaymentName, Description, AccessToken)
            .then(() => {
                dispatch(updatePaymentMethodComplete())
            })
    }
}

export const updateFeatureFlag = (id, Active, FeatureName, FeatureDescription, PricePerMonth) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateFeatureFlagBegin())

        return putFeatureFlag(token, id, Active, FeatureName, FeatureDescription, PricePerMonth)
            .then(() => {
                dispatch(updateFeatureFlagComplete())
            })
    }
}

export const updateTenantFeatureFlag = (id, TenantID, FeatureFlagID, InContract = true) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateTenantFeatureFlagBegin())

        return putTenantFeatureFlag(token, id, TenantID, FeatureFlagID, InContract)
            .then(() => {
                dispatch(updateTenantFeatureFlagComplete())
            })
    }
}

export const updateUserCertificate = (id, TenantID, LanguageID) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateUserCertificateBegin())

        return putUserCertificate(token, id, TenantID, LanguageID)
            .then(() => {
                dispatch(updateUserCertificateComplete())
            })
    }
}

export const updateTenantSettings = (DBNameNumberSeries) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateTenantSettingsBegin())

        return putTenantSettings(token, DBNameNumberSeries)
            .then(() => {
                dispatch(updateTenantSettingsComplete())
            })
    }
}

export const updateTenantFeaturesAdjusted = (id, FeaturesAdjusted) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateTenantBegin())

        return postTenantFeaturesAdjusted(token, id, FeaturesAdjusted)
            .then(() => {
                dispatch(updateTenantSuccess())
            })
    }
}

export const updateTenantDataVerified = (id, DataVerified) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(updateTenantBegin())

        return postTenantDataVerified(token, id, DataVerified)
            .then(() => {
                dispatch(updateTenantSuccess())
            })
    }
}


export const removeUser = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteUserBegin())

        return deleteUser(token, id)
            .then(()=>{
                dispatch(deleteUserSuccess())
            })
    }
}

export const removeTenant = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteTenantBegin())

        return deleteTenant(token, id)
            .then(()=>{
                dispatch(deleteTenantSuccess())
            })
    }
}

export const removeUserTenantConnection = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteUserTenantConnectionBegin())

        return deleteUserTenantConnection(token, id)
            .then(()=>{
                dispatch(deleteUserTenantConnectionSuccess())
            })
    }
}

export const removeLanguage = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteLanguageBegin())

        return deleteLanguage(token, id)
            .then(() => {
                dispatch(deleteLanguageComplete())
            })
    }
}

export const removeTenantLanguage = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteTenantLanguageBegin())

        return deleteTenantLanguage(token, id)
            .then(() => {
                dispatch(deleteTenantLanguageComplete())
            })
    }
}

export const removePaymentMethod = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deletePaymentMethodBegin())

        return deletePaymentMethod(token, id)
            .then(() => {
                dispatch(deletePaymentMethodComplete())
            })
    }
}

export const removeFeatureFlag = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteFeatureFlagBegin())

        return deleteFeatureFlag(token, id)
            .then(() => {
                dispatch(deleteFeatureFlagComplete())
            })
    }
}

export const removeTenantFeatureFlag = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteTenantFeatureFlagBegin())

        return deleteTenantFeatureFlag(token, id)
            .then(() => {
                dispatch(deleteTenantFeatureFlagComplete())
            })
    }
}

export const removeUserCertificate = (id) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState()

        dispatch(deleteUserCertificateBegin())

        return deleteUserCertificate(token, id)
            .then(() => {
                dispatch(deleteUserCertificateComplete())
            })
    }
}

export const fetchTenantData = (table, dbName) => {
    return (dispatch) => {
        
        dispatch(fetchTenantDataBegin())

        return getTenantData(table, dbName)
        .then(res => {
            dispatch(fetchTenantDataComplete(res))

            return res
        })
    }
}

export const startMigration = (tenantId) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(startMigrationBegin());

        return postStartMigration(token, tenantId)
            .then(res => {
                dispatch(startMigrationSuccess(res));
            });
    }
}

export const startTestMigration = (tenantId) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(startTestMigrationBegin());

        return postStartTestMigration(token, tenantId)
            .then(res => {
                dispatch(startTestMigrationSuccess(res));
            })
    }
}

export const checkGadgetMigrationStatus = (tenantId) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(checkGadgetMigrationStatusBegin());

        return getGadgetMigrationStatus(token, tenantId)
            .then(res => {
                dispatch(checkGadgetMigrationStatusSuccess(res));

                return res;
            });
    }
}

export const checkGadgetTestMigrationStatus = (tenantId) => {
    return (dispatch, getState) => {
        const {
            app: { token }
        } = getState();

        dispatch(checkGadgetTestMigrationStatusBegin());

        return getGadgetTestMigrationStatus(token, tenantId)
            .then(res => {
                dispatch(checkGadgetTestMigrationStatusSuccess(res));

                return res;
            });
    }
}
